import { create } from 'zustand'

import { AppMode, resolveAppMode } from './appMode/appMode'

interface IAppModeState {
    mode: AppMode
    setMode: (mode: AppMode) => void
    isWithoutCrypto: boolean
    setIsWithoutCrypto: (isWithoutCrypto: boolean) => void
}

const initialMode =
  typeof window === 'undefined' ? 'default' : resolveAppMode(window.location.hostname)

export const useAppModeStore = create<IAppModeState>((set) => ({
    mode: initialMode,
    setMode: (mode) => set({ mode }),
    isWithoutCrypto: false,
    setIsWithoutCrypto: (isWithoutCrypto) => set({ isWithoutCrypto }),
}))
